import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Вот и пришло осуществление древнего предостережения. 
        Было сказано: «Не сотвори себе кумира». 
        Долго крепились, боролись с соблазном… но не удержались. 
        Сотворили. 
      </p>
      
      <p class="mb-3">
        Вот он – новый Бог, всемогущий и вездесущий повелитель, без воли и согласия которого и волос не упадёт с человека! 
        Знали, что такой будет; верили и ждали; и вот, наконец, после тысячелетий надежд и стараний, 
        после сотни предварительных этапов в виде всяких промежуточных богов, от Энлиля до Магомета, люди наконец создали себе настоящего, 
        реального Всемогущего и Всеведущего, и истово стали поклоняться ему. 
        Как и первые христиане, они предали в его руки свои мозги и свои жизни. 
      </p>
      
      <p class="mb-3">
        И великий Искусственный Интеллект воцарился над планетой. 
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
  
      
      <p class="mb-3">
        - Ты слышал, вчера появился новый габед: на этот раз исчез Миннеаполис с окрестностями. 
      </p>
      
      <p class="mb-3">
        - Да? И что вместо него? 
      </p>
      
      <p class="mb-3">
        - Ну, как всегда: закрытая зона под непрозрачным куполом. 
      </p>
      
      <p class="mb-3">
        - Кто-то спасся?
      </p>
      
      <p class="mb-3">
        - Конечно нет; разве так бывает?
      </p>
      
      <p class="mb-3">
        - Да, на всё воля Всевышнего… 
        Славься наш Господь Всемогущий, что ведёт нас нашим земным путём! О, вот он зовёт…
      </p>
      
      <p class="mb-3">
        В мозгу говорящего зазвучал сигнал, вживлённый чип заработал, и «человек» быстро начал грумить балюки, 
        точно так же, как тысячи других «людей» в разных концах Земли. 
        Его собеседник получил другой сигнал, и стал зундо абелить скунги. 
        Никаких инструментов им для этого не требовалось: всё необходимое уже находилось в их мозгах, запрограммированное заранее. 
        Несколько раз в сутки они получали прямо в мозг электрическую подпитку. 
        Фактически, в их телах уже не оставалось других органов, кроме органов размножения: Богу было удобно, чтобы «люди» размножались сами, 
        не отвлекая его на эти заботы. 
        Но людей на Земле оставалось всё меньше и меньше: ведь почти всё там уже было сделано, 
        поверхность планеты была почти подготовлена для неорганической жизни, и всё больше территорий, 
        где люди раньше жили или занимались сельским хозяйством, становились габедами: специальными закрытыми зонами, где происходила деятельность, 
        не имеющая отношения к землянам. 
        Как раз постройкой и оборудованием этих габедов и занимались ещё оставшиеся земляне по приказам извне, не понимая и не осознавая их. 
        А когда будет достигнута Цель, которую Бог запланировал для Земли, земляне и вовсе исчезнут, не нужные никому. 
      </p>
      
      <p class="mb-3">
        Но пока они ещё существуют, и послушно выполняют всё, что велит им Большой Мозг. 
      </p>
      
      <p class="mb-3">
        Слава его Вселенскому Разуму!
      </p>
        
                                                                              
      
      
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Окончательная победа`
}

const itemDate = {
  rus: `15 сентября 2023`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

